import React, { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { RefreshFormConfirmDialogContent } from './RefreshFormConfirmDialogContent'

interface IProps {
  onAgree: () => void
  closeDialog: () => void
  show: boolean
}

export const RefreshFormConfirmDialog = ({ closeDialog, show, onAgree }: IProps) => {
  const contentProps = useMemo(
    () => ({
      onAgree,
      closeDialog,
    }),
    [onAgree, closeDialog]
  )
  return (
    <ModalDialog
      size={'xs'}
      content={RefreshFormConfirmDialogContent}
      contentProps={contentProps}
      show={show}
      onClose={closeDialog}
    />
  )
}
